/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SrvProceedingCourseEntryRequest
 */
export interface SrvProceedingCourseEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryRequest
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingCourseEntryRequest
     */
    dateUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryRequest
     */
    entryType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryRequest
     */
    result?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingCourseEntryRequest
     */
    remark?: string | null;
}

/**
 * Check if a given object implements the SrvProceedingCourseEntryRequest interface.
 */
export function instanceOfSrvProceedingCourseEntryRequest(value: object): value is SrvProceedingCourseEntryRequest {
    if (!('dateUtc' in value) || value['dateUtc'] === undefined) return false;
    return true;
}

export function SrvProceedingCourseEntryRequestFromJSON(json: any): SrvProceedingCourseEntryRequest {
    return SrvProceedingCourseEntryRequestFromJSONTyped(json, false);
}

export function SrvProceedingCourseEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingCourseEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dateUtc': (new Date(json['dateUtc'])),
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'result': json['result'] == null ? undefined : json['result'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

export function SrvProceedingCourseEntryRequestToJSON(json: any): SrvProceedingCourseEntryRequest {
    return SrvProceedingCourseEntryRequestToJSONTyped(json, false);
}

export function SrvProceedingCourseEntryRequestToJSONTyped(value?: SrvProceedingCourseEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dateUtc': value['dateUtc'].toISOString(),
        'entryType': value['entryType'],
        'result': value['result'],
        'remark': value['remark'],
    };
}

